import { useAuth } from "../AuthProvider";
import { checkAuthAccess } from "../services/helpers";

export const useAuthAccess = ({ serviceKey, permissionKey, action }) => {
    const { user, isLoading } = useAuth();
    const userPermissions = user?.permissions || user?.userPermissions || {};

    const { canAccess, isServiceEnabled, hasPermission } = checkAuthAccess({
        userPermissions,
        activeServices: user.allowedServices ?? [],
        serviceKey,
        permissionKey,
        action
    });

    return {
        canAccess,
        isServiceEnabled,
        hasPermission,
        isLoading
    };
};